import * as service from './service'
export default {
  namespace: 'walletBankCardList',
  state: {
    cardList: []
  },
  effects: {
    * queryCourierBankCard ({ payload }, { call, put }) {
      const res = yield call(service.queryCourierBankCard, payload)
      yield put({
        type: 'save',
        payload: {
          cardList: res.data.data
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
